export default __webpack_public_path__ + "static/media/about.d79b8887.jpg";